<template>
    <div class="tabs__container"
         :class="{
            'tabs__container--overflow-notification': width_li > width_el,
            'tabs__container--end-reached': end_reached
        }">
        <ul class="tabs">
            <li v-for="link in links" :key="link.name">
                <router-link @click.native="moveTabToVisibleArea" v-if="use_router" class="tabs__link"
                             :to="{name: link.name}" :active-class="'tabs__link--active'">
                    {{link.label}}
                </router-link>
                <div v-if="!use_router" class="tabs__link"
                     @click="updateTabLocation(link.name)"
                     v-bind:class="{'tabs__link--active': tab_location === link.name}">
                    {{link.label}}
                </div>
            </li>
        </ul>
        <div class="tabs__next-element-button" @click="scrollTabs"></div>
    </div>
</template>
<script>
    import $ from 'jquery';

    export default {
        name: 'Tabs',
        data: function () {
            return {
                width_li: 0,
                width_el: 0,
                end_reached: false,
                tab_location: this.value
            }
        },
        props: {
            value: {
                type: String,
                required: false,
                default: function() {
                    return ''
                },
            },
            links: {
                type: Array,
                default: function () {
                    return []
                },
                required: true
            },
            use_router: {
                type: Boolean,
                default: function () {
                    return true
                }
            }
        },
        methods: {
            moveTabToVisibleArea: function(object) {
                console.log(object.target)
            },
            scrollTabs: function() {
                let component_to_scroll = $(this.$el).find('.tabs')
                let component_width = component_to_scroll.outerWidth()
                let tabs = $(this.$el).find('.tabs li')
                let initial_scroll = component_to_scroll.scrollLeft()
                let size = component_to_scroll.outerWidth(true) + initial_scroll
                let current_width = 0
                let visible_width = 0
                let tab_not_visible_width_first = 0
                let tab_not_visible_width_second = 0
                let initial_offset = 0
                let left_side_navigation_width = 0


                $(this.$el).find('li').each(function (index) {
                    current_width += $(this).outerWidth(true)

                    if (current_width > size) {
                        tab_not_visible_width_first = tabs.eq(index).outerWidth(true)
                        if (index + 1 < tabs.length) {
                            tab_not_visible_width_second = tabs.eq(index + 1).outerWidth(true)
                        }
                        return false
                    }
                    else {
                        visible_width += $(this).outerWidth(true)
                    }
                });

                initial_offset = visible_width + tab_not_visible_width_first - size

                if (this.end_reached !== true) {
                    // Check if hidden tab is less than 50% visible
                    if (size - visible_width < (visible_width + tab_not_visible_width_first) - size) {
                        component_to_scroll.animate({
                            scrollLeft: initial_scroll + initial_offset
                        }, 200)
                    }
                    else {
                        component_to_scroll.animate({
                            scrollLeft: initial_scroll + initial_offset + tab_not_visible_width_second
                        }, 200)
                    }

                    // If end is reached
                    if (window.innerWidth > 980 && !$(".desktop-navigation__toggle").hasClass("desktop-navigation__toggle--hidden")) {
                        left_side_navigation_width = 290
                    } else {
                        left_side_navigation_width = 0
                    }

                    if (tabs.eq(tabs.length - 2).offset().left - left_side_navigation_width < component_width) {
                        this.end_reached = true
                    }
                }
                else {
                    component_to_scroll.animate({
                        scrollLeft: 0
                    }, "slow")
                    this.end_reached = false
                }
            },
            updateTabLocation: function(name) {
                this.tab_location = name
                this.$emit('input', name)
            },
            calculateWidth: function () {
                let width_li = 0
                let width_el = $(this.$el).width()
                $(this.$el).find('li').each(function () {
                    width_li += $(this).outerWidth(true)
                });
                this.width_li = width_li
                this.width_el = width_el
            }
        },
        created() {
            window.addEventListener("resize", this.calculateWidth);
        },
        mounted() {
            this.calculateWidth()
        },
        updated() {
            this.calculateWidth()
        },
        destroyed() {
            window.removeEventListener("resize", this.calculateWidth);
        },
    }
</script>
